$(document).ready(function(){
	$('.dropdown__toggle').on('click', function(e){
		e.preventDefault();
		if ($(window).width() >= 1024) {
			if ($(this).parent().hasClass('level--2') == true) {
				window.location = $(this).attr("data-href");
			}
			if ($(this).next('.dropdown__list').hasClass('open')) {
				$('.dropdown__list').removeClass('open');
			} else {
				$('.dropdown__list').removeClass('open');
				$(this).next('.dropdown__list').addClass('open');
			}
		} else {
			$(this).next('.dropdown__list').toggleClass('open');
		}
	});
	$('.dropdown__hz__toggle').on('click', function(){
		$(this).find('svg').toggleClass('-rotate-90');
		$(this).next('.dropdown__hz__list').toggleClass('open');
	});
});